export default __webpack_public_path__ + "static/media/linkedin.88930774.svg";